/* eslint-disable consistent-return */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import { Badge, Col, Image, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router';
import { useOnlineStore } from '../../../contexts/onlineStoreContext';
import { StyledBottomText, StyledValueBottomText } from '../Base/styles';
import cartImg from '../../../assets/icons/cart.png';
import ConfirmInvoiceModal from '../Invoice/ConfirmModal';
import { listGeneratorsRoute, listReadyKits } from '../../../routes/config';
import getFreightValue from '../../../utils/getFreightValue';
import useInvoiceFreight from '../../../hooks/useInvoiceFreight';

const TopCart: React.FC = () => {
    const history = useHistory();

    const { cart, setStep, productType } = useOnlineStore();
    const [sum, setSum] = useState(0);
    const [totalValue, setTotalValue] = useState(0);
    const [showConfirmInvoiceModal, setShowConfirmInvoiceModal] =
        useState(false);

    const viewSummary = () => {
        if (!cart?.invoiceItems.length) {
            return toast.info('Seu carrinho está vazio');
        }

        if (productType === 'PA' || productType === 'BF') {
            history.push(listReadyKits.path, { viewSummary: true });
        }

        if (productType === 'MP') {
            history.push(listGeneratorsRoute.path, { viewSummary: true });
        }

        setStep(3);
    };

    useEffect(() => {
        const calc = async () => {
            setSum(0);
            let subtotal = 0;
            cart?.invoiceItems?.forEach((item: any) => {
                subtotal += item.totalValue;
                setSum((sum) => (sum += item.quantity));
            });
            setTotalValue(subtotal);
        };

        calc();
    }, [cart, cart.invoiceItems]);

    const { data: freightPercentage = 0 } = useInvoiceFreight(
        cart.id,
        cart.freightPercentage,
    );

    const freightValue = getFreightValue(totalValue, freightPercentage);
    const finalTotal = totalValue + freightValue;

    return (
        <div
            style={{ cursor: 'pointer' }}
            onClick={() => {
                viewSummary();
            }}
            className="w-100 mt-2 mr-3"
        >
            <Row>
                <Col xl={4}>
                    <div className={'mt-1 mr-n4 float-right'}>
                        <Image className={'mr-n2'} src={cartImg}></Image>

                        <sup className={'superscript'}>
                            <Badge
                                className={'ml-1 notify-badge'}
                                variant={'primary'}
                            >
                                {sum}
                            </Badge>
                        </sup>
                    </div>
                </Col>
                <Col xl={8}>
                    <StyledValueBottomText>
                        {finalTotal.toLocaleString('pt-br', {
                            style: 'currency',
                            currency: 'BRL',
                        })}
                    </StyledValueBottomText>

                    <StyledBottomText className={'mt-n2'}>
                        ver resumo
                    </StyledBottomText>
                </Col>
            </Row>

            <ConfirmInvoiceModal
                show={showConfirmInvoiceModal}
                invoiceId={cart.id}
                type={cart.type}
                onHide={() => {
                    setShowConfirmInvoiceModal(false);
                }}
            />
        </div>
    );
};

export default TopCart;
